import { elements, modifiers, helpers } from '#components/generics/js/styles.js'
import * as utilities from '#utilities/js/styles.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import mutations from '@mailobj-browser/front/js/tree/mutations.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'

const options = {
  childList: true,
  subtree: true
}

export default (wrapper) => {
  const xaddrs = one(`.${helpers.xaddrs.block}`, wrapper)
  const checkboxList = one(`.${modifiers.new_field_input.new_checkbox}[name="new_attendee_list"]`, wrapper)
  const fieldList = closest(`.${elements.new_field}`, checkboxList)

  queueMicrotask(async () => {
    for await (const { target } of mutations(xaddrs, options, removed(xaddrs))) {
      const itemsOK = all(`.${helpers.xaddrs.modifiers.item.ok}`, target)

      if (itemsOK.length > 0) {
        fieldList.classList.remove(utilities.modifiers.display.none)
        checkboxList.removeAttribute('disabled')
      } else {
        fieldList.classList.add(utilities.modifiers.display.none)
        checkboxList.setAttribute('disabled', '')
      }
    }
  })
}
